<template>
  <div class="flex flex-row justify-between p-2 class-color flex-fill">
    <div class="flex flex-row items-center space-x-6">
      <!-- <img alt="Paroma-Med" class="h-12 cursor-pointer" :src="imageLogoOnDark" @click="goToRoot" /> -->
    </div>

    <div class="hidden md:flex">
      <auth-menu />
    </div>

    <div class="flex flex-col p-4 align-center md:hidden" v-if="isAuthenticated != 'Undefined'">
      <MenuAlt1Icon class="text-white w-8 h-8 cursor-pointer" @click.stop="drawer = !drawer" />
    </div>

    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      dark
      class="primary md:hidden"
      id="left-sidebar"
      hide-overlay
      v-if="isAuthenticated != 'Undefined'"
    >
      <v-list nav class="py-12">
        <template v-for="item in items">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ !mini ? item.heading : '' }}
              </v-subheader>
            </v-col>
          </v-row>
          <v-divider v-else-if="item.divider" :key="item.heading" class="my-2"></v-divider>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.icon"
            :append-icon="'mdi-chevron-down'"
            color="inherit"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title :data-cy="item.text">
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              link
              :to="child.to"
              class="pl-10"
              :data-cy="child.text"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title :data-cy="child.text">
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else-if="item.text === 'Logout'" :key="item.text" @click="logout">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title :data-cy="item.text">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-else-if="item.loggedIn" :key="item.text" link :to="item.to">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title :data-cy="item.text">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn block @click="logout">
            {{ $t('logout') }}
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-menu v-if="isAuthenticated == 'Undefined'" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <div class="flex flex-col p-4 align-center md:hidden">
          <MenuAlt1Icon
            class="text-white w-8 h-8 cursor-pointer"
            @click.stop="drawer = !drawer"
            v-bind="attrs"
            v-on="on"
          />
        </div>
      </template>
      <v-list>
        <template v-for="it in items">
          <v-list-item v-if="!it.loggedIn" :key="it.text" link :to="it.to">
            <v-list-item-title>{{ it.text }}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api';
import imageLogoOnDark from '@/assets/logo-on-dark.png';
import AuthMenu from '@/components/authentication/AuthMenu.vue';
import store from '@/store/store';
import router from '@/router';
import { MenuAlt1Icon } from '@vue-hero-icons/outline';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import util from '@/mixins/util.js';

export default defineComponent({
  name: 'NavigationHeader',
  mixins: [util],
  components: { AuthMenu, MenuAlt1Icon, LanguageSwitcher },
  computed: {
    items() {
      return [
        {
          loggedIn: false,
          icon: 'mdi-login-variant',
          text: this.$i18n.t('login.title'),
          to: {
            name: 'LogIn',
          },
        },
        {
          loggedIn: false,
          icon: 'mdi-account-plus-outline',
          text: this.$i18n.t('sign-up'),
          to: {
            name: 'SignUp',
          },
        },
        {
          loggedIn: true,
          icon: 'mdi-view-dashboard',
          text: this.$i18n.t('dashboard'),
          to: {
            name: 'Dashboard',
          },
        },
        {
          loggedIn: true,
          icon: 'mdi-magnify',
          text: this.$i18n.tc('asset.title', 1),
          to: {
            name: 'Assets',
          },
        },
        {
          loggedIn: true,
          icon: 'mdi-server',
          text: this.$i18n.tc('fileServer.title', 1),
          to: {
            name: 'FileServer',
          },
        },
      ];
    },
  },
  data() {
    return {
      drawer: null,
    };
  },
  setup() {
    var isAuthenticated = computed(() => store.getters.fullName);

    const goToRoot = () => {
      if (isAuthenticated.value == 'Undefined') {
        router.push({ path: '/', query: {} }).catch(() => {});
      } else {
        router
          .push({
            name: 'Dashboard',
          })
          .catch(() => {});
      }
    };

    return { imageLogoOnDark, goToRoot, isAuthenticated };
  },
});
</script>
<style>
.class-color {
  background: linear-gradient(90deg, #1a237e 0%, #1b2a8a 30%, #283593 60%, #303f9f 100%);
  box-shadow: 4px 0 24px rgba(26, 35, 126, 0.18);
}
</style>
